import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CompletionPage.css';

const CompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    // Session cleanup
    const sessionId = sessionStorage.getItem('audioGuideSessionId');
    if (sessionId) {
      console.log('Cleaning up session:', sessionId);
      // TODO: Call Firebase Functions API to cleanup session
      sessionStorage.removeItem('audioGuideSessionId');
    }

    // Show animation after component mounts
    const timer = setTimeout(() => {
      setShowAnimation(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleRestart = () => {
    // Clear any remaining session data
    sessionStorage.clear();
    localStorage.removeItem('audioGuideProgress');

    // Navigate back to landing page
    navigate('/');
  };

  const handleVisitHepFive = () => {
    // Open HEP-FIVE official website
    window.open('https://umeda-sc.jp/en/hep-five/', '_blank');
  };

  return (
    <div className="completion-page">
      {/* Background Container */}
      <div className="background-container">
        <img
          src="/hep-five-primary-image.jpg"
          alt="HEP-FIVE Ferris Wheel View"
          className="background-image"
        />
        <div className="background-overlay"></div>
      </div>

      {/* Content Container */}
      <div className="completion-content">
        {/* Main Completion Message */}
        <div className={`completion-message ${showAnimation ? 'animate' : ''}`}>
          <div className="celebration-icon">🎉</div>

          <h1 className="completion-title">
            Thank You for Riding the HEP-FIVE Ferris Wheel!
          </h1>

          <p className="completion-subtitle">
            From the sky, Osaka looks a little different. <br />
            We hope today you discovered its beauty in new ways, <br />
            only possible from HEP FIVE.
          </p>

          <div className="experience-summary">
            <div className="summary-item">
              <span className="summary-icon">🎧</span>
              <span className="summary-text">Audio Journey Enjoyed</span>
            </div>
            <div className="summary-item">
              <span className="summary-icon">🌃</span>
              <span className="summary-text">New Osaka Perspectives</span>
            </div>
            <div className="summary-item">
              <span className="summary-icon">💖</span>
              <span className="summary-text">Memory with HEP FIVE</span>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="action-section">
          <button className="primary-action" onClick={handleVisitHepFive}>
            Visit HEP-FIVE Website
          </button>

          <button className="secondary-action" onClick={handleRestart}>
            Experience Again
          </button>
        </div>

        {/* Social Sharing Encouragement */}
        <div className="sharing-section">
          <p className="sharing-text">
            Share your HEP-FIVE experience with friends and family!
          </p>
          <div className="sharing-hashtag">
            #HEPFIVE #OsakaViews #DiscoverOsaka
          </div>
        </div>

        {/* Credits Section */}
        <div className="credits-section">
          {/* Re:Sense Technology Credit */}
          <div className="tech-credit">
            <span className="credit-label">Powered by</span>
            <img
              src="/resense-streaming-logo.png"
              alt="Re:Sense STREAMING"
              className="resense-logo-completion"
            />
          </div>

          {/* Company Attribution */}
          <div className="company-credit">
            <span className="operated-by">Operated by</span>
            <span className="company-name">Clepseadra, Inc.</span>
          </div>

          {/* Copyright */}
          <div className="copyright">
            <span>© 2025 HEP FIVE OSAKA UMEDA</span>
          </div>
        </div>

        {/* HEP-FIVE Logo */}
        <div className="logo-container">
          <img
            src="/hep-five-logo.svg"
            alt="HEP-FIVE"
            className="hep-five-logo"
          />
        </div>
      </div>

      {/* Floating Elements Animation */}
      <div className="floating-elements">
        <div className="floating-star star-1">⭐</div>
        <div className="floating-star star-2">✨</div>
        <div className="floating-star star-3">🌟</div>
        <div className="floating-cloud cloud-1">☁️</div>
        <div className="floating-cloud cloud-2">☁️</div>
      </div>
    </div>
  );
};

export default CompletionPage;
